import { render } from "./item10000.vue?vue&type=template&id=10b1323d&scoped=true"
import script from "./item10000.vue?vue&type=script&lang=js"
export * from "./item10000.vue?vue&type=script&lang=js"

import "./item10000.vue?vue&type=style&index=0&id=10b1323d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b1323d"]])

export default __exports__